import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pickTable" }
const _hoisted_2 = { style: {"position":"absolute","bottom":"13px","left":"20px","z-index":"12"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("clear")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Remove")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_checkbox = _resolveComponent("imdex-checkbox")!
  const _component_imdex_table = _resolveComponent("imdex-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_imdex_btn, {
        mini: "",
        highlight: "",
        onClick: _ctx.clearPickDataStore
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_imdex_table, {
      stickyFooter: "",
      stickyHeader: "",
      dense: "",
      highlightable: "",
      tableData: _ctx.tableData
    }, {
      "h-select": _withCtx(() => [
        _createVNode(_component_imdex_checkbox, {
          value: _ctx.selectAllFiles,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectAllFiles) = $event))
        }, null, 8, ["value"])
      ]),
      select: _withCtx((prop) => [
        _createVNode(_component_imdex_checkbox, {
          value: prop.row.select,
          "onUpdate:value": ($event: any) => ((prop.row.select) = $event),
          onClick: _ctx.selectRow
        }, null, 8, ["value", "onUpdate:value", "onClick"])
      ]),
      delete: _withCtx((prop) => [
        _createVNode(_component_imdex_btn, {
          onClick: prop,
          text: "",
          secondary: "",
          compact: ""
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["tableData"])
  ]))
}